import { useEffect, useState } from "react";
import { observeConversation } from "..";

import type { Conversation } from "../types";

/**
 * Hook to subscribe to conversation updates.
 * @param conversationId The ID of the conversation to observe
 * @returns The current state of the conversation messages and any draft content
 */
export default function useConversation(conversationId: string | undefined) {
  const [conversation, setConversation] = useState<Conversation | undefined>(
    undefined,
  );

  // Subscribe to userConversation updates
  useEffect(() => {
    setConversation(undefined); // reset the conversation state when the conversationId changes
    if (!conversationId) {
      return;
    }

    const subscription =
      observeConversation(conversationId).subscribe(setConversation);
    return () => subscription.unsubscribe();
  }, [conversationId]);

  return conversation;
}
